import type { Answer } from '../shared/index.js';

export const s = {
  name: 'Kimim Ben?',
  pitch: 'Alnındaki kartı herkes görüyor, bir tek sen bilmiyorsun',
  answers: { yes: 'Evet', no: 'Hayır', maybe: 'Belki', irrelevant: 'Alakasız' } satisfies Record<Answer, string>,
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    categories: 'Kimlikler nereden gelsin',
    categoriesHint: 'Herkese seçili kategorilerden rastgele bir kimlik düşer.',
    turnMode: 'Soru hakkı',
    classic: 'Hayır çıkana kadar',
    classicHint: 'Cevap “Evet”, “Belki” ya da “Alakasız” oldukça sormaya devam edersin.',
    three: 'Her turda 3 soru',
    threeHint: 'Cevaplar ne olursa olsun 3 sorudan sonra sıra geçer.',
    typed: 'Yazılı soru',
    typedHint: 'Soruyu sesli sormanın yanında yazabilirsin de; soru geçmişinde kalır.',
    verify: 'Tahmin kontrolü',
    auto: 'Otomatik',
    autoHint: 'Yazım farkları (ş/s, büyük harf, boşluk) ve takma adlar kabul edilir.',
    group: 'Grup onaylasın',
    groupHint: 'Diğerleri yazılan tahmini görüp “Doğru” ya da “Yanlış” der.',
    hints: 'Kişi başı ipucu',
    hintsHint: (n: number) =>
      n === 0 ? 'İpucu yok.' : `Sırayla kategori, baş harf, harf sayısı. Her ipucu 1 soru sayılır.`,
    on: 'Açık',
    off: 'Kapalı',
    add: 'Kendi kimliğini ekle',
    addHint: 'Eklediğin kimlik “Arkadaş kartları”na girer; kimseye listelenmez, sana da düşmez.',
    addName: 'Kimlik (ör. Bizim Hasan)',
    addAliases: 'Başka yazımlar, virgülle (ör. hasan, hasan abi)',
    save: 'Kimliği ekle',
    saving: 'Ekleniyor…',
    saved: (n: string) => `“${n}” eklendi.`,
  },
  play: {
    turn: (n: number) => `Tur ${n}`,
    you: 'sen',
    yourCard: 'Senin kartın',
    unknown: '?',
    asking: 'soruyor',
    finished: (place: number) => `${place}. bildi`,
    questions: (n: number) => `${n} soru`,
    left: 'ayrıldı',
    offline: 'bağlantı yok',

    myTurn: 'Sıra sende',
    myTurnHint: (mode: 'classic' | 'three', left: number) =>
      mode === 'classic'
        ? 'Evet/hayır ile cevaplanacak bir soru sor. “Hayır” çıkana kadar sormaya devam edersin.'
        : `Evet/hayır ile cevaplanacak bir soru sor. Bu turda ${left} soru hakkın kaldı.`,
    questionPlaceholder: 'Sorunu yaz (isteğe bağlı)',
    askedAloud: 'Soruyu sordum',
    askTyped: 'Soruyu gönder',
    guessTitle: 'Kim olduğunu biliyor musun?',
    guessPlaceholder: 'Kimliğini yaz',
    guess: 'Tahmin et',
    guessHint: 'Yanlış tahmin sırayı geçirir.',
    passMine: 'Sırayı geçir',

    waitAsk: (nick: string) => `${nick} sorusunu düşünüyor.`,
    skip: (nick: string) => `${nick} adlı oyuncuyu atla`,
    voiceQuestion: 'Sesli soruyu dinle ve cevapla.',
    answerTitle: (nick: string) => `${nick} soruyor`,
    cardIs: 'kartı:',
    nextUp: (nick: string) => `Sırada ${nick}`,
    lastAnswer: 'Son cevap:',
    guessLabel: 'Kimliğini yaz',
    myQuestion: 'Sorun cevaplanıyor',
    myQuestionVoice: 'Sesli sorduğun soru',
    answered: (n: number, total: number) => `${n}/${total} kişi cevapladı`,
    voted: (n: number, total: number) => `${n}/${total} kişi oyladı`,
    closeNow: 'Gelen cevaplarla bitir',

    guessPendingMine: (text: string) => `Tahminin: “${text}”`,
    guessPendingMineHint: 'Diğerleri doğru mu diye oyluyor.',
    guessPending: (nick: string) => `${nick} tahmin etti`,
    guessCard: 'Kartında yazan',
    correct: 'Doğru',
    wrong: 'Yanlış',
    closeVote: 'Oylamayı bitir',
    votes: (c: number, w: number) => `${c} doğru, ${w} yanlış`,

    hintsTitle: 'İpuçların',
    hintButton: (left: number) => `İpucu al (${left} hak)`,
    hintNote: 'İpucunu yalnızca sen görürsün; 1 soru sayılır.',

    done: (place: number) => `Bildin, ${place}. sıradasın`,
    doneHint: 'Diğerlerinin sorularını cevaplamaya devam et.',
    youAre: 'Sen',

    historyTitle: 'Soru geçmişi',
    historyEmpty: 'Henüz soru sorulmadı. İlk soru genelde “İnsan mıyım?” olur.',
    voice: 'Sesli soru',
    guessed: (text: string) => `Tahmin: “${text}”`,
    skipped: 'Sırası atlandı',
    skippedHost: 'Oda sahibi sırasını atladı',
    byGroup: 'grup onayı',
    mine: 'Yalnızca benim',
    all: 'Herkes',

    progressTitle: 'Oyuncular',
  },
  podium: {
    title: 'Oyun bitti',
    winner: (nick: string) => `${nick} kazandı!`,
    asked: (n: number) => `${n} soruda bildi`,
    ranking: 'Sıralama',
    none: 'Kimse bilemedi',
    place: (n: number) => `${n}.`,
    questions: (n: number) => `${n} soru`,
    notFound: 'bilemedi',
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Kartın alnında', 'Herkesin alnında bir kimlik var. Başkalarınınkini görürsün, kendininkini göremezsin.'],
      ['Sorunu sor', 'Sıra sana gelince evet/hayır ile cevaplanacak bir soru sor: “İnsan mıyım?”, “Yaşıyor muyum?”'],
      ['Cevapla', 'Diğerleri Evet, Hayır, Belki ya da Alakasız der; çoğunluk geçerli olur. “Hayır” çıkınca sıra geçer.'],
      ['Tahmin et', 'Bildiğini düşündüğünde kimliğini yaz. Doğruysa bitirirsin, yanlışsa sıra geçer.'],
      ['Sıralama', 'Herkes bilince en az soruda bilen kazanır. Bilenler cevaplamaya devam eder.'],
    ] as [string, string][],
  },
};
